import React from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Button
} from "@material-ui/core";
import SentroLoading from "../../../../loading";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector, useDispatch } from "react-redux";
import Utils from "../../../../utils";
import { bankListing } from "../../../../../websiteBuilder/forms/bankContants";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import { orderUpdatePayment } from "../websiteBuilderActions";
const DialogTransition = props => <Slide direction="up" {...props} />;
const MobileUpdatePayment = props => {
  const dispatch = useDispatch();
  const { open, setOpen } = props;
  const useStyles = makeStyles(theme => ({
    appBar: {
      position: "fixed",
      backgroundColor: "#fafafa",
      boxShadow: "none",
      borderBottom: "1px solid #d1d5dd"
    },
    header: {
      color: "#002c42",
      fontSize: 16,
      fontWeight: 600,
      textAlign: "center",
      width: "100%"
    },
    closeBtn: { position: "absolute", left: 15 },
    refId: {
      fontSize: 14,
      fontWeight: 600,
      color: "#002c42"
    }
  }));
  const classes = useStyles();
  const loading = useSelector(state => state.mobileDashboard.loading);
  const selectedOrder = useSelector(
    state => state.mobileDashboard.orders.selectedOrder
  );
  let payments = [
    "Other Banks",
    "Cash",
    // "GCash",
    "PayMaya",
    "PayPal"
  ];
  let [bankName, setBankName] = React.useState("UnionBank of the Philippines");
  let [update, setUpdate] = React.useState({
    id: "",
    channel: "",
    date: new Date()
  });

  function updatePayment() {
    let channel = update.channel;
    if (update.channel === "Other Banks") {
      channel = bankName;
    }

    let params = {
      id: selectedOrder.id,
      channel: channel,
      date: moment(update.date).format()
    };
    dispatch(orderUpdatePayment(params));
    setOpen(false);
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Dialog fullScreen open={open} TransitionComponent={DialogTransition}>
        <SentroLoading open={loading} />
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              className={classes.closeBtn}
              onClick={() => setOpen(false)}
            >
              <CloseIcon color="primary" />
            </IconButton>
            <div className={classes.header}>Mark as Paid</div>
          </Toolbar>
        </AppBar>
        <div
          style={{ paddingTop: "8vh", position: "relative", height: "100vh" }}
        >
          <div style={{ padding: 20 }}>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className={classes.refId}>
                  Reference No. {selectedOrder ? selectedOrder.ref_id : ""}
                </div>
                <div
                  style={{
                    fontSize: 14,
                    color: "#002c42",
                    fontWeight: "bold",
                    textTransform: "capitalize"
                  }}
                >
                  {selectedOrder ? selectedOrder.full_name : ""}
                </div>
              </div>
              <div
                style={{ fontSize: 14, color: "#0d3d76", fontWeight: "bold" }}
              >
                PHP {Utils.commafy(selectedOrder ? selectedOrder.amount : 0)}
              </div>
            </div>
            <div style={{ paddingTop: "5vh" }}>
              <div style={{ fontSize: 14, color: "#2b2d33", fontWeight: 600 }}>
                What was the payment method used?
              </div>
              <RadioGroup
                onChange={e =>
                  setUpdate({
                    ...update,
                    channel: e.target.value
                  })
                }
                defaultValue={selectedOrder ? selectedOrder.channel : "Cash"}
                color="primary"
              >
                {payments.map((item, key) => {
                  return (
                    <FormControlLabel
                      key={key}
                      color="secondary"
                      value={item}
                      control={<Radio color="primary" />}
                      label={item}
                    />
                  );
                })}
                {update.channel === "Other Banks" ? (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12, color: "#2b2d33" }}>
                      Select bank
                    </div>
                    <Select
                      margin="dense"
                      fullWidth
                      id="bank_name"
                      value={bankName}
                      variant="outlined"
                      onChange={e => setBankName(e.target.value)}
                    >
                      {bankListing.map((item, key) => {
                        return (
                          <MenuItem value={item.name}>{item.name}</MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                ) : (
                  ""
                )}
              </RadioGroup>
              <div style={{ marginTop: "2vh" }}>
                <div
                  style={{ fontSize: 14, color: "#2b2d33", fontWeight: 600 }}
                >
                  When was the payment done?
                </div>
                <KeyboardDateTimePicker
                  margin="dense"
                  inputVariant="outlined"
                  value={update.date}
                  onChange={e => setUpdate({ ...update, date: e })}
                  style={{ margin: 0, padding: 0 }}
                  ampm={false}
                  format="dd MMMM yyyy hh:mm"
                />
              </div>
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              padding: 20,
              bottom: 0
            }}
          >
            <Button
              fullWidth
              disableElevation
              variant="contained"
              color="primary"
              style={{ height: 40 }}
              onClick={updatePayment}
            >
              Submit
            </Button>
          </div>
        </div>
      </Dialog>
    </MuiPickersUtilsProvider>
  );
};

export default MobileUpdatePayment;
